<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_xi"></a><a id="not"></a></p>
<h2 class="h2a">Note on Translations</h2>
<p class="noindent1">A comparative study like this one relies on the efforts of many different translators, who sometimes use different systems of rendering the original language into English. I have used the best translations I could find for each quoted text, and altered the spellings of certain names and titles to conform to my understanding of current transliteration standards.<a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// not.vue?8426657a